// Animation timing values. Exposed for use in js-based animations.
const timing = {
    default: 200,
} as const;

const easing = {
    default: "cubic-bezier(0.3, 0.3, 0.2, 1)",
} as const;

const animation = {
    default: `200ms ${easing.default}`,
} as const;

export const motion = {
    easing,
    animation,
    timing,
} as const;
